import { RotateCw } from 'lucide-react'
import { CustomDatePicker } from '../../../../components/CustomDatePicker'
import { Button, Dropdown } from '../../../../components'
import {
  LEAVE_STATUS_FILTER_OPTIONS,
  LEAVE_TYPE_FILTER_OPTIONS,
} from '../constants/hrmsLeaveRequests.constants'

interface LeaveFiltersProps {
  typeFilter: string
  onTypeFilterChange: (val: string) => void
  statusFilter: string
  onStatusFilterChange: (val: string) => void
  fromDate: string
  onFromDateChange: (val: string) => void
  toDate: string
  onToDateChange: (val: string) => void
  onClearFilters: () => void
  typeOptions?: Array<{ label: string; value: string }>
}

export function LeaveFilters({
  typeFilter,
  onTypeFilterChange,
  statusFilter,
  onStatusFilterChange,
  fromDate,
  onFromDateChange,
  toDate,
  onToDateChange,
  onClearFilters,
  typeOptions,
}: LeaveFiltersProps) {
  const baseTypeOptions =
    typeOptions && typeOptions.length > 0 ? typeOptions : LEAVE_TYPE_FILTER_OPTIONS

  const formattedTypeOptions = baseTypeOptions.map((opt) =>
    opt.value === '' || opt.value === 'All' ? { label: 'Type: All', value: '' } : opt
  )
  const statusOptions = LEAVE_STATUS_FILTER_OPTIONS.map((opt) =>
    opt.value === '' || opt.value === 'All' ? { label: 'Status: All', value: '' } : opt
  )

  const hasActiveFilters =
    Boolean(typeFilter && typeFilter !== 'All') ||
    Boolean(statusFilter && statusFilter !== 'All') ||
    Boolean(fromDate) ||
    Boolean(toDate)

  return (
    <div className="flex flex-wrap items-center gap-3 min-w-0 font-sans">
      <div className="h-11 w-full sm:w-[170px] flex-none [&>*]:h-full [&_input]:h-full [&_button]:h-full">
        <Dropdown
          options={formattedTypeOptions}
          value={typeFilter === 'All' ? '' : typeFilter}
          onChange={onTypeFilterChange}
          variant="filled"
          placeholder="Type: All"
          className="w-full h-full"
        />
      </div>

      <div className="h-11 w-full sm:w-[170px] flex-none [&>*]:h-full [&_input]:h-full [&_button]:h-full">
        <Dropdown
          options={statusOptions}
          value={statusFilter === 'All' ? '' : statusFilter}
          onChange={onStatusFilterChange}
          variant="filled"
          placeholder="Status: All"
          className="w-full h-full"
        />
      </div>

      {/* DATE RANGE */}
      <div className="flex items-center gap-1.5">
        <div className="h-11 w-full sm:w-[170px] flex-none [&>*]:h-full [&_input]:h-full [&_button]:h-full">
          <CustomDatePicker
            value={fromDate}
            onChange={onFromDateChange}
            maxDate={toDate || undefined}
            placeholder="From date"
            buttonClassName="h-11 rounded-xl text-xs font-medium"
          />
        </div>
        <span className="text-gray-400 font-medium text-xs shrink-0">-</span>
        <div className="h-11 w-full sm:w-[170px] flex-none [&>*]:h-full [&_input]:h-full [&_button]:h-full">
          <CustomDatePicker
            value={toDate}
            onChange={onToDateChange}
            minDate={fromDate || undefined}
            placeholder="To date"
            buttonClassName="h-11 rounded-xl text-xs font-medium"
          />
        </div>
      </div>

      {/* CLEAR FILTERS */}
      {hasActiveFilters ? (
        <div className="h-11 flex-none flex items-center">
          <Button
            variant="secondary"
            size="md"
            icon={<RotateCw className="h-3.5 w-3.5" />}
            onClick={onClearFilters}
            className="border-none text-[#146971] hover:bg-[#146971]/10 font-bold text-xs h-11 px-3"
          >
            Clear Filters
          </Button>
        </div>
      ) : null}
    </div>
  )
}
